import axios from '../axiosConfig.jsx'

export async function editLocation(payload, locationId) {
    return await axios.put(`/partners/locations/detail`, { ...payload, 'LocationId': locationId }).then(res => res.data)
}

export async function deleteLocation(locationId) {
    console.log("Rec Delete loc id..", locationId);
    return await axios.delete(`/partners/locations`, { data: { 'locationId': locationId } }).then(res => res.data)
}